<template>
  <div class="matches">
    <header-bar></header-bar>

    <section style="margin-top: 100px;">
      <div class="grid-container">

        <h1>Delete a user:</h1>
        <input class="" type="text" v-model.trim="userid" placeholder="User UID" required />
        <input type="submit" value="Delete User" class="btn btn-big bg-two active" style="margin-top: 50px; background-position: 50% 553px;" v-on:click.stop.prevent="deleteUser">
      </div>
      <div class="grid-container">
      {{ userdata }}
      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'

export default {
  name: 'Matches',
  props: ['personality'],
  components: {
    HeaderBar
  },
  data () {
    return {
      userid: 'CacCUlrjf9WOIJD4InWIBAzP5qE3',
      userdata: null,
      userchats: null
    }
  },

  methods: {
    deleteUser () {
      if (this.userid) {
        this.$bindAsObject('userdata', db.ref('users').child(this.userid))
        this.$bindAsObject('userchats', db.ref('users-chats').child(this.userid))
      }
    }
  },
  watch: {
    userdata: function (val) {
      if (val['.key']) {
        // Delete user-meta/reputation/userid
        db.ref('user-meta/reputation/' + this.userid).remove()

        // Delete user-meta/notifications/userid
        db.ref('user-meta/notifications/' + this.userid).remove()

        // Delete user-meta/SLUG
        if (val.slug) {
          db.ref('user-meta/slug/' + val.slug).remove()
        }

        // For each skill, remove that user
        if (val.personality['have-skills']) {
          for (var item1 in val.personality['have-skills']) {
            db.ref('attributes/skills/' + item1 + '/users/' + this.userid).remove()
          }
          for (var item2 in val.personality['want-skills']) {
            db.ref('attributes/skills/' + item2 + '/users/' + this.userid).remove()
          }
        }

        // // For each focus area
        for (var item3 in val.personality['focus-areas']) {
          db.ref('attributes/focus-areas/' + item3 + '/users/' + this.userid).remove()
        }

        // // For each country
        for (var item4 in val.personality['countries']) {
          db.ref('attributes/countries/' + item4 + '/users/' + this.userid).remove()
        }

        // Delete user/userid
        db.ref('users/' + this.userid).remove()

        alert('User Removed')
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// DeleteUser.vue?7a470959